module.exports = {"130128100":"深泽镇","130128101":"铁杆镇","130128102":"赵八镇","130128200":"白庄乡","130128201":"留村乡","130128203":"桥头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130128.json
// module id = 70
// module chunks = 0